export const BURDEN_STATEMENTS = {
  'SF-424B': {
    ombn: '4040-0007',
    expDate: '02/28/2025',
    text: `<div>
    Public reporting burden for this collection of information is estimated to average 15 minutes per response, including time for reviewing instructions, searching existing data sources, gathering and maintaining the data needed, and completing and reviewing the collection of information. Send comments regarding the burden estimate or any other aspect of this collection of information, including suggestions for reducing this burden, to the Office of Management and Budget, Paperwork Reduction Project (0348-0040), Washington, DC 20503.
<br/><br/>
PLEASE DO NOT RETURN YOUR COMPLETED FORM TO THE OFFICE OF MANAGEMENT AND BUDGET. SEND IT TO THE ADDRESS PROVIDED BY THE SPONSORING AGENCY.
<br/><br/>
According to the Paperwork Reduction Act of 1995, an agency may not conduct or sponsor, and a person is not required to respond to a collection of information unless it displays a valid OMB control number. The valid OMB control number for this information collection is 4040-0007. The time required to complete this information collection is estimated to average 49 minutes per response, includeing the time to review instructions, search existing data resources, gather the data needed and complete and review the information collection. If you have comments concerning the accuracy of the time estimate(s) or suggestions for improving this form, please write to: U.S. Department of Health & Human Services, OS/OCIO/PRA, 200 Independence Ave. S.W., Suite 537-H, Washington D.c. 20201, Attention: PRA Reports Clearance Officer.
    <table summary='FEMA GO data table' class='ui celled table'>
        <thead class=''>
            <tr scope='row' class='top aligned'>
                <th scope='col' class='left aligned'>Agency</th>
                <th scope='col' class='left aligned'>Total Responses</th>
                <th scope='col' class='left aligned'>Average Burden per response in Hours</th>
                <th scope='col' class='left aligned'>Total Burden in Hours</th>
            </tr>
        </thead>
        <tbody class=''>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>USDA</td>
                <td class='left aligned femaGoTableTextCell'>6202</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>1551</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>NARA</td>
                <td class='left aligned femaGoTableTextCell'>145</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>36</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>CNCS</td>
                <td class='left aligned femaGoTableTextCell'>10</td>
                <td class='left aligned femaGoTableTextCell'>30/60</td>
                <td class='left aligned femaGoTableTextCell'>5</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>TREAS</td>
                <td class='left aligned femaGoTableTextCell'>191</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>48</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>DOI</td>
                <td class='left aligned femaGoTableTextCell'>3848</td>
                <td class='left aligned femaGoTableTextCell'>22/60</td>
                <td class='left aligned femaGoTableTextCell'>1404</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>VA</td>
                <td class='left aligned femaGoTableTextCell'>184</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>46</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>DOC</td>
                <td class='left aligned femaGoTableTextCell'>5685</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>1421</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>EPA</td>
                <td class='left aligned femaGoTableTextCell'>9098</td>
                <td class='left aligned femaGoTableTextCell'>1.82</td>
                <td class='left aligned femaGoTableTextCell'>16585</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>DHS</td>
                <td class='left aligned femaGoTableTextCell'>150</td>
                <td class='left aligned femaGoTableTextCell'>1</td>
                <td class='left aligned femaGoTableTextCell'>150</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>HHS</td>
                <td class='left aligned femaGoTableTextCell'>978</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>245</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>Total</td>
                <td class='left aligned femaGoTableTextCell'>26491</td>
                <td class='left aligned femaGoTableTextCell'></td>
                <td class='left aligned femaGoTableTextCell'>21491</td>
            </tr>
        </tbody>
    </table>
21491 total hrs x 60 min. = 1289460 total minutes
<br/><br/>
1289460 / 26491 total responses = 49 minutes per response</div>`,
  },
  '112-0-3C': {
    ombn: '1660-0083',
    expDate: '10/31/2021',
    text: `<div>
        Public reporting burden for this form is estimated to average 1.7 hours per response. The burden estimate includes the time for reviewing instructions, searching existing data sources, gathering and maintaining the data needed, and completing, and submitting the form. This collection of information is required to obtain or retain benefits. You are not required to submit to this collection of information unless it displays a valid OMB control number. Send comments regarding the accuracy of the burden estimate and any suggestions for reducing the burden to: Information Collections Management, Department of Homeland Security, Federal Emergency Management Agency, 500 C Street SW, Washington, DC 20472-3100, and Paperwork Reduction Project (1660-0083). NOTE: Do not send your completed form to this address.
    <br/><br/>
    Please use the following Field definition for "Certifications regarding lobbying; Debarment, Suspension and other responsibility matters; and Drug-free workplace requirements” assurance:
    
        <table summary='FEMA GO data table' class='ui celled table'>
            <thead class=''>
                <tr scope='row' class='top aligned'>
                    <th scope='col' class='left aligned'>Field label</th>
                    <th scope='col' class='left aligned'>Answer</th>
                    <th scope='col' class='left aligned'>Required?</th>
                </tr>
            </thead>
            <tbody class=''>
                <tr scope='row' class='top aligned'>
                    <td class='left aligned femaGoTableTextCell'>Standard Form-LLL "Disclosure of Lobbying Activities" attached</td>
                    <td class='left aligned femaGoTableTextCell'>Check box</td>
                    <td class='left aligned femaGoTableTextCell'>No</td>
                </tr>
                <tr scope='row' class='top aligned'>
                    <td class='left aligned femaGoTableTextCell'>Place of Performance (Street address, City, County, State, Zip code)</td>
                    <td class='left aligned femaGoTableTextCell'>Text box: 324 max character</td>
                    <td class='left aligned femaGoTableTextCell'>No</td>
                </tr>
                <tr scope='row' class='top aligned'>
                    <td class='left aligned femaGoTableTextCell'>If there are workplaces on file that are not identified</td>
                    <td class='left aligned femaGoTableTextCell'>Check box</td>
                    <td class='left aligned femaGoTableTextCell'>No</td>
                </tr>
            </tbody>
        </table>
        </div>`,
  },
  'SF-LLL': {
    ombn: '4040-0013',
    expDate: '02/28/2025',
    text: `According to the Paperwork Reduction Act, as amended, no persons are required to respond to a collection of information unless it displays a valid OMB Control Number. The valid OMB control number for this information collection is OMB No. 4040-0013. Public reporting burden for this collection of information is estimated to average 10 minutes per response, including time for reviewing instructions, searching existing data sources, gathering and maintaining the data needed, and completing and reviewing the collection of information. Send comments regarding the burden estimate or any other aspect of this collection of information, including suggestions for reducing this burden, to the Office of Management and Budget, Paperwork Reduction Project (4040-0013), Washington, DC 20503.`,
  },
  'SF-424D': {
    ombn: '4040-0009',
    expDate: '02/28/2025',
    text: `<div>
    Public reporting burden for this collection of information is estimated to average 15 minutes per response, including time for reviewing instructions, searching existing data sources, gathering and maintaining the data needed, and completing and reviewing the collection of information. Send comments regarding the burden estimate or any other aspect of this collection of information, including suggestions for reducing this burden, to the Office of Management and Budget, Paperwork Reduction Project (0348-0040), Washington, DC 20503.
<br/><br/>
PLEASE DO NOT RETURN YOUR COMPLETED FORM TO THE OFFICE OF MANAGEMENT AND BUDGET. SEND IT TO THE ADDRESS PROVIDED BY THE SPONSORING AGENCY.
<br/><br/>
According to the Paperwork Reduction Act of 1995, an agency may not conduct or sponsor, and a person is not required to respond to a collection of information unless it displays a valid OMB control number. The valid OMB control number for this information collection is 4040-0009. The time required to complete this information collection is estimated to average 30 minutes per response, including the time to review instructions, search existing data resources, gather the data needed and complete and review the information collection. If you have comments concerning the accuracy of the time estimate(s) or suggestions for improving this form, please write to: U.S. Department of Health & Human Services, OS/OCIO/PRA, 200 Independence Ave., S.W., Suite 537-H, Washington D.C. 20201, Attention: PRA Reports Clearance Officer.
    <table summary='FEMA GO data table' class='ui celled table'>
        <thead class=''>
            <tr scope='row' class='top aligned'>
                <th scope='col' class='left aligned'>Agency</th>
                <th scope='col' class='left aligned'>Total Responses</th>
                <th scope='col' class='left aligned'>Average Burden per response in Hours</th>
                <th scope='col' class='left aligned'>Total Burden in Hours</th>
            </tr>
        </thead>
        <tbody class=''>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>USDA</td>
                <td class='left aligned femaGoTableTextCell'>916</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>229</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>DOI</td>
                <td class='left aligned femaGoTableTextCell'>1334</td>
                <td class='left aligned femaGoTableTextCell'>48/60</td>
                <td class='left aligned femaGoTableTextCell'>1076</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>VA</td>
                <td class='left aligned femaGoTableTextCell'>141</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>35</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>DOC</td>
                <td class='left aligned femaGoTableTextCell'>567</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>142</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>DHS</td>
                <td class='left aligned femaGoTableTextCell'>73</td>
                <td class='left aligned femaGoTableTextCell'>30/60</td>
                <td class='left aligned femaGoTableTextCell'>37</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>HHS</td>
                <td class='left aligned femaGoTableTextCell'>978</td>
                <td class='left aligned femaGoTableTextCell'>15/60</td>
                <td class='left aligned femaGoTableTextCell'>245</td>
            </tr>
            <tr scope='row' class='top aligned'>
                <td class='left aligned femaGoTableTextCell'>Total</td>
                <td class='left aligned femaGoTableTextCell'>3031</td>
                <td class='left aligned femaGoTableTextCell'></td>
                <td class='left aligned femaGoTableTextCell'>1519</td>
            </tr>
        </tbody>
    </table>
1519 total hrs x 60 min. = 91140 total minutes
<br/><br/>
91140 / 3031 total responses = 30 minutes per response</div>`,
  },
};
